export default "__VITE_ASSET__892fb3bb__"